var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty__image"},[_c('img',{attrs:{"src":_vm.image,"alt":"Here is not thing."}})]),_c('p',{staticClass:"empty__description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }